// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --primary-white: #fff;
    --primary-black: #000;
    --primary-grey: #73739a;
    --primary-grey2: #f5f5f5;
    --primary-blue: #6d72f6;
    --primary-green: #08ce8a;
    --primary-black2: #1c1c57;
}

.SubscribePopups-popup-modal {
    display: flex;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
    justify-content: center;
    align-items: center;
    z-index: 99999;
    overflow: hidden; 
}

.SubscribePopups-popup-modal::before {
    content: '';
    position: absolute;
    width: 150%;
    height: 150%;
    background: radial-gradient(circle, rgba(109, 114, 246, 0.6), transparent 60%);
    animation: floatingGlow 6s infinite alternate ease-in-out;
    top: -50%;
    left: -50%;
    z-index: -1;
}

.SubscribePopups-popup-modal::after {
    content: '';
    position: absolute;
    width: 200px;
    height: 200px;
    background: rgba(8, 117, 206, 0.6);
    border-radius: 50%;
    animation: floatCircle 8s infinite ease-in-out;
    top: 20%;
    right: 15%;
    z-index: -1;
}

.SubscribePopups-popup-modal-content {
    background: linear-gradient(to bottom, #E3E4FF 80%, #8084FF 100%);
    backdrop-filter: blur(1px);
    padding: 30px 20px;
    border-radius: 50px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    max-width: 500px;
    width: 100%;
    text-align: center;
    position: relative;
    overflow: hidden;
    margin: 10px 20px;
    animation: slideInFromTop 0.8s ease-out; 
}

.SubscribePopups-popup-close-btn {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
    font-size: 22px;
    transition: 0.3s linear;
}

.SubscribePopups-popup-close-btn:hover {
    color: #ff0000;
}

.SubscribePopups-popup-title-box {
    margin: 24px 0 30px 0;
}

.SubscribePopups-popup-inp-box {
    gap: 12px;
    display: flex;
    margin-bottom: 25px;
    flex-direction: column;
}

.SubscribePopups-popup-inp-box input {
    width: 100%;
    border: none;
    outline: none;
    padding: 12px 20px;
    border-radius: 22px;
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.2);
}

.SubscribePopups-popup-icon-box{
    position: relative;
}

.SubscribePopups-popup-icon-box input{
    padding-left: 35px;
}

.SubscribePopups-popup-icon-box svg{
    position: absolute;
    top: 12px;
    left: 12px;
    color: var(--primary-blue);
}

.SubscribePopups-popup-inp-box-2{
    display: flex;
    gap: 10px;
}

.SubscribePopups-popup-inp-min-box{
    flex: 1 1 100%;
}

.SubscribePopups-popup-inp-box-2 label{
    font-size: 12px;
}

.SubscribePopups-popup-btn-box {
    text-align: center;
}

.SubscribePopups-popup-btn-box button {
    border: none;
    cursor: pointer;
    padding: 16px 2rem;
    border-radius: 30px;
    transition: 0.3s linear;
    color: var(--primary-white);
    background-color: var(--primary-blue);
}

.SubscribePopups-popup-btn-box button:hover {
    box-shadow: 0px 0px 6px #494edd;
}

/* Animation from the top */
@keyframes slideInFromTop {
    from {
        transform: translateY(-100%);
        opacity: 0.8;
    }
    to {
        transform: translateY(0);
        opacity: 1;
    }
}

/* Keyframes for glowing background */
@keyframes floatingGlow {
    0% {
        transform: scale(1) translate(0, 0);
        opacity: 0.8;
    }
    100% {
        transform: scale(1.5) translate(10%, 10%);
        opacity: 0.4;
    }
}

/* Keyframes for floating circle */
@keyframes floatCircle {
    0% {
        transform: translateY(0) translateX(0);
        opacity: 0.6;
    }
    50% {
        transform: translateY(-30px) translateX(20px);
        opacity: 0.8;
    }
    100% {
        transform: translateY(0) translateX(0);
        opacity: 0.6;
    }
}

@media (max-width: 480px){
    .SubscribePopups-popup-title-box h2{
        font-size: 18px;
    }
    .SubscribePopups-popup-inp-box-2{
        flex-direction: column;
    }
}


.SubscribePopups-popup-icon-box textarea {
    width: 100%;
    border: none;
    outline: none;
    padding: 12px 20px;
    border-radius: 22px;
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.2);
    resize: none; /* Prevents resizing */
    min-height: 100px; /* Default height */
    padding-left: 35px; /* Space for the icon */
}

.SubscribePopups-popup-icon-box textarea::placeholder {
    color: var(--primary-grey); /* Placeholder color */
}

.SubscribePopups-popup-icon-box svg {
    position: absolute;
    top: 12px; /* Align with input text */
    left: 12px;
    color: var(--primary-blue);
}

@media (max-width: 480px) {
    .SubscribePopups-popup-icon-box textarea {
        min-height: 80px; /* Adjust height for smaller screens */
        padding: 10px 15px;
        font-size: 14px; /* Smaller font size for readability */
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/SubscribePopup/SubscribePopup.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,uBAAuB;IACvB,wBAAwB;IACxB,uBAAuB;IACvB,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,0BAA0B;IAC1B,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,8EAA8E;IAC9E,yDAAyD;IACzD,SAAS;IACT,UAAU;IACV,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,kCAAkC;IAClC,kBAAkB;IAClB,8CAA8C;IAC9C,QAAQ;IACR,UAAU;IACV,WAAW;AACf;;AAEA;IACI,iEAAiE;IACjE,0BAA0B;IAC1B,kBAAkB;IAClB,mBAAmB;IACnB,uCAAuC;IACvC,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,uCAAuC;AAC3C;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;IACf,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,qCAAqC;AACzC;;AAEA;IACI,+BAA+B;AACnC;;AAEA,2BAA2B;AAC3B;IACI;QACI,4BAA4B;QAC5B,YAAY;IAChB;IACA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA,qCAAqC;AACrC;IACI;QACI,mCAAmC;QACnC,YAAY;IAChB;IACA;QACI,yCAAyC;QACzC,YAAY;IAChB;AACJ;;AAEA,kCAAkC;AAClC;IACI;QACI,sCAAsC;QACtC,YAAY;IAChB;IACA;QACI,6CAA6C;QAC7C,YAAY;IAChB;IACA;QACI,sCAAsC;QACtC,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,sBAAsB;IAC1B;AACJ;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,0CAA0C;IAC1C,YAAY,EAAE,sBAAsB;IACpC,iBAAiB,EAAE,mBAAmB;IACtC,kBAAkB,EAAE,uBAAuB;AAC/C;;AAEA;IACI,0BAA0B,EAAE,sBAAsB;AACtD;;AAEA;IACI,kBAAkB;IAClB,SAAS,EAAE,0BAA0B;IACrC,UAAU;IACV,0BAA0B;AAC9B;;AAEA;IACI;QACI,gBAAgB,EAAE,sCAAsC;QACxD,kBAAkB;QAClB,eAAe,EAAE,sCAAsC;IAC3D;AACJ","sourcesContent":[":root {\n    --primary-white: #fff;\n    --primary-black: #000;\n    --primary-grey: #73739a;\n    --primary-grey2: #f5f5f5;\n    --primary-blue: #6d72f6;\n    --primary-green: #08ce8a;\n    --primary-black2: #1c1c57;\n}\n\n.SubscribePopups-popup-modal {\n    display: flex;\n    position: fixed;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    backdrop-filter: blur(4px);\n    justify-content: center;\n    align-items: center;\n    z-index: 99999;\n    overflow: hidden; \n}\n\n.SubscribePopups-popup-modal::before {\n    content: '';\n    position: absolute;\n    width: 150%;\n    height: 150%;\n    background: radial-gradient(circle, rgba(109, 114, 246, 0.6), transparent 60%);\n    animation: floatingGlow 6s infinite alternate ease-in-out;\n    top: -50%;\n    left: -50%;\n    z-index: -1;\n}\n\n.SubscribePopups-popup-modal::after {\n    content: '';\n    position: absolute;\n    width: 200px;\n    height: 200px;\n    background: rgba(8, 117, 206, 0.6);\n    border-radius: 50%;\n    animation: floatCircle 8s infinite ease-in-out;\n    top: 20%;\n    right: 15%;\n    z-index: -1;\n}\n\n.SubscribePopups-popup-modal-content {\n    background: linear-gradient(to bottom, #E3E4FF 80%, #8084FF 100%);\n    backdrop-filter: blur(1px);\n    padding: 30px 20px;\n    border-radius: 50px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n    max-width: 500px;\n    width: 100%;\n    text-align: center;\n    position: relative;\n    overflow: hidden;\n    margin: 10px 20px;\n    animation: slideInFromTop 0.8s ease-out; \n}\n\n.SubscribePopups-popup-close-btn {\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    cursor: pointer;\n    font-size: 22px;\n    transition: 0.3s linear;\n}\n\n.SubscribePopups-popup-close-btn:hover {\n    color: #ff0000;\n}\n\n.SubscribePopups-popup-title-box {\n    margin: 24px 0 30px 0;\n}\n\n.SubscribePopups-popup-inp-box {\n    gap: 12px;\n    display: flex;\n    margin-bottom: 25px;\n    flex-direction: column;\n}\n\n.SubscribePopups-popup-inp-box input {\n    width: 100%;\n    border: none;\n    outline: none;\n    padding: 12px 20px;\n    border-radius: 22px;\n    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.2);\n}\n\n.SubscribePopups-popup-icon-box{\n    position: relative;\n}\n\n.SubscribePopups-popup-icon-box input{\n    padding-left: 35px;\n}\n\n.SubscribePopups-popup-icon-box svg{\n    position: absolute;\n    top: 12px;\n    left: 12px;\n    color: var(--primary-blue);\n}\n\n.SubscribePopups-popup-inp-box-2{\n    display: flex;\n    gap: 10px;\n}\n\n.SubscribePopups-popup-inp-min-box{\n    flex: 1 1 100%;\n}\n\n.SubscribePopups-popup-inp-box-2 label{\n    font-size: 12px;\n}\n\n.SubscribePopups-popup-btn-box {\n    text-align: center;\n}\n\n.SubscribePopups-popup-btn-box button {\n    border: none;\n    cursor: pointer;\n    padding: 16px 2rem;\n    border-radius: 30px;\n    transition: 0.3s linear;\n    color: var(--primary-white);\n    background-color: var(--primary-blue);\n}\n\n.SubscribePopups-popup-btn-box button:hover {\n    box-shadow: 0px 0px 6px #494edd;\n}\n\n/* Animation from the top */\n@keyframes slideInFromTop {\n    from {\n        transform: translateY(-100%);\n        opacity: 0.8;\n    }\n    to {\n        transform: translateY(0);\n        opacity: 1;\n    }\n}\n\n/* Keyframes for glowing background */\n@keyframes floatingGlow {\n    0% {\n        transform: scale(1) translate(0, 0);\n        opacity: 0.8;\n    }\n    100% {\n        transform: scale(1.5) translate(10%, 10%);\n        opacity: 0.4;\n    }\n}\n\n/* Keyframes for floating circle */\n@keyframes floatCircle {\n    0% {\n        transform: translateY(0) translateX(0);\n        opacity: 0.6;\n    }\n    50% {\n        transform: translateY(-30px) translateX(20px);\n        opacity: 0.8;\n    }\n    100% {\n        transform: translateY(0) translateX(0);\n        opacity: 0.6;\n    }\n}\n\n@media (max-width: 480px){\n    .SubscribePopups-popup-title-box h2{\n        font-size: 18px;\n    }\n    .SubscribePopups-popup-inp-box-2{\n        flex-direction: column;\n    }\n}\n\n\n.SubscribePopups-popup-icon-box textarea {\n    width: 100%;\n    border: none;\n    outline: none;\n    padding: 12px 20px;\n    border-radius: 22px;\n    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.2);\n    resize: none; /* Prevents resizing */\n    min-height: 100px; /* Default height */\n    padding-left: 35px; /* Space for the icon */\n}\n\n.SubscribePopups-popup-icon-box textarea::placeholder {\n    color: var(--primary-grey); /* Placeholder color */\n}\n\n.SubscribePopups-popup-icon-box svg {\n    position: absolute;\n    top: 12px; /* Align with input text */\n    left: 12px;\n    color: var(--primary-blue);\n}\n\n@media (max-width: 480px) {\n    .SubscribePopups-popup-icon-box textarea {\n        min-height: 80px; /* Adjust height for smaller screens */\n        padding: 10px 15px;\n        font-size: 14px; /* Smaller font size for readability */\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
